// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"WeatherForecast_sidebarWrapper__InP2z"};